import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { MODEL_PROPTYPES } from "../../models";
import PropTypes from "prop-types";
import { RadiometricTargetSaveForm } from "./RadiometricTargetSaveForm";
import { useSnackbar } from "../../hooks";

RadiometricTargetSaveModal.propTypes = {
    open: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    radioMetricTargetPolygonRef: PropTypes.object.isRequired,
    orthoimageCompany: PropTypes.shape(MODEL_PROPTYPES.Company),
    orthoimageContract: PropTypes.shape(MODEL_PROPTYPES.Contract),
    orthoimageSite: PropTypes.shape(MODEL_PROPTYPES.Site),
    orthoimageMission: PropTypes.shape(MODEL_PROPTYPES.Mission),
    existingGeometry: PropTypes.object,
    refetchMissionGeometries: PropTypes.func,
};

export function RadiometricTargetSaveModal({
    open,
    setIsOpen,
    radioMetricTargetPolygonRef,
    orthoimageCompany,
    orthoimageContract,
    orthoimageSite,
    orthoimageMission,
    existingGeometry,
    refetchMissionGeometries,
}) {
    const { openSnackbar } = useSnackbar();
    return (
        <Dialog open={open} fullWidth maxWidth="sm">
            <DialogTitle>
                <Stack
                    direction="row"
                    sx={{ borderBottom: 1, borderColor: "divider" }}
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Typography variant="h5">
                        Save radiometric target
                    </Typography>
                    <IconButton
                        onClick={() => {
                            setIsOpen(false);
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent sx={{ bgcolor: "background.default" }}>
                <RadiometricTargetSaveForm
                    setIsOpen={setIsOpen}
                    radioMetricTargetPolygonRef={radioMetricTargetPolygonRef}
                    openSnackbar={openSnackbar}
                    orthoimageCompany={orthoimageCompany}
                    orthoimageContract={orthoimageContract}
                    orthoimageSite={orthoimageSite}
                    orthoimageMission={orthoimageMission}
                    existingGeometry={existingGeometry}
                    refetchMissionGeometries={refetchMissionGeometries}
                />
            </DialogContent>
        </Dialog>
    );
}
